export const filterOption = (value, options) => (
    options.filter(
        optionToSelect => String(optionToSelect.value) === String(value),
    )
);

export const setDefaultValue = (defaultOption, options) => {
    if (typeof defaultOption === 'object') {
        return defaultOption;
    }
    return filterOption(defaultOption, options);
};
